import { render, staticRenderFns } from "./boardForm.vue?vue&type=template&id=862284f8&scoped=true&"
import script from "./boardForm.vue?vue&type=script&lang=js&"
export * from "./boardForm.vue?vue&type=script&lang=js&"
import style0 from "./boardForm.vue?vue&type=style&index=0&id=862284f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862284f8",
  null
  
)

export default component.exports